import classnames from 'classnames';
import React, { FC, useState } from 'react';
import { ConnectedBankAccount } from 'src/invoice/types/types';

import styles from './connected-accounts.less';
import { ConnectedAccount } from './connected-account';

interface ConnectedAccountsProps {
    accounts: ConnectedBankAccount[];
    setAccounts: (accounts: ConnectedBankAccount[]) => void;
}

export const ConnectedAccounts: FC<ConnectedAccountsProps> = ({
    accounts,
    setAccounts
}) => {

    const [, setConnectedAccounts] = useState(accounts);

    const onSelectConnectedAccount = (index: number) => {
        accounts.forEach(account => { account.selected = false; });
        accounts[index].selected = true;
        setConnectedAccounts([...accounts]);
        setAccounts(accounts);
    }

    return (
        <>
            {accounts.length > 0 && (
                <div className={classnames('connected-accounts-container', styles.connectedAccountsContainer)}>
                    <div className={classnames('connected-accounts-header', styles.connectedAccountsHeader)}>Connected Account(s)</div>
                    {accounts.map((account, idx) => (
                        <div key={account.accountId} className={classnames('connected-accounts-item',
                            styles.connectedAccountsItem)}
                            onClick={() => onSelectConnectedAccount(idx)}>
                            <ConnectedAccount
                                account={account}
                            />
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}